/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareHomeHealthAdmission
 */
export interface MatrixCareHomeHealthAdmission {
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    status: MatrixCareHomeHealthAdmissionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    error_message?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    external_admission_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    external_patient_id?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MatrixCareHomeHealthAdmission
     */
    submitted_form_data: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    submitted_at: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthAdmission
     */
    submitted_by_user_id?: string;
}


/**
 * @export
 */
export const MatrixCareHomeHealthAdmissionStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Succeeded: 'succeeded',
    Failed: 'failed'
} as const;
export type MatrixCareHomeHealthAdmissionStatusEnum = typeof MatrixCareHomeHealthAdmissionStatusEnum[keyof typeof MatrixCareHomeHealthAdmissionStatusEnum];


/**
 * Check if a given object implements the MatrixCareHomeHealthAdmission interface.
 */
export function instanceOfMatrixCareHomeHealthAdmission(value: object): value is MatrixCareHomeHealthAdmission {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('submitted_form_data' in value) || value['submitted_form_data'] === undefined) return false;
    if (!('submitted_at' in value) || value['submitted_at'] === undefined) return false;
    return true;
}

export function MatrixCareHomeHealthAdmissionFromJSON(json: any): MatrixCareHomeHealthAdmission {
    return MatrixCareHomeHealthAdmissionFromJSONTyped(json, false);
}

export function MatrixCareHomeHealthAdmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareHomeHealthAdmission {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'error_message': json['error_message'] == null ? undefined : json['error_message'],
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'],
        'external_admission_id': json['external_admission_id'] == null ? undefined : json['external_admission_id'],
        'external_patient_id': json['external_patient_id'] == null ? undefined : json['external_patient_id'],
        'submitted_form_data': json['submitted_form_data'],
        'submitted_at': json['submitted_at'],
        'submitted_by_user_id': json['submitted_by_user_id'] == null ? undefined : json['submitted_by_user_id'],
    };
}

export function MatrixCareHomeHealthAdmissionToJSON(json: any): MatrixCareHomeHealthAdmission {
    return MatrixCareHomeHealthAdmissionToJSONTyped(json, false);
}

export function MatrixCareHomeHealthAdmissionToJSONTyped(value?: MatrixCareHomeHealthAdmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'error_message': value['error_message'],
        'id': value['id'],
        'lead_id': value['lead_id'],
        'external_admission_id': value['external_admission_id'],
        'external_patient_id': value['external_patient_id'],
        'submitted_form_data': value['submitted_form_data'],
        'submitted_at': value['submitted_at'],
        'submitted_by_user_id': value['submitted_by_user_id'],
    };
}

